/* eslint-disabled */

export default class PackFileExtend {


  constructor (object?: any) {
  }

}
